// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

window.textStickyAnimation = function textStickyAnimation() {
  if (window.innerWidth > 1024) {
    let tl = gsap.timeline();
    const stickyTextArr = document.querySelectorAll('[data-text-sticky]');
    if (stickyTextArr.length >= 1) {
      setTimeout(function () {
        stickyTextArr.forEach((stickyEl) => {
          const section = stickyEl.closest('section');
          const wrap = section?.querySelector('.cont');

          if (!section || !wrap) {
            return;
          }

          const wrapRect = wrap.getBoundingClientRect();
          const stickyRect = stickyEl.getBoundingClientRect();

          const distance = stickyRect.top - wrapRect.top;

          let trackHeight = wrap.clientHeight - distance;

          if (stickyEl.classList.contains('if-minus-height-el')) {
            trackHeight = wrap.clientHeight - distance - stickyEl.clientHeight;
          }

          /*console.log(trackHeight);*/

          let start = `top top+=${window.innerHeight < 810 ? 120 : 190}`;

          if (stickyEl.classList.contains('if-centered-position')) {
            let centerPosition =
              window.innerHeight / 2 - stickyEl.clientHeight / 2;

            if (stickyEl.classList.contains('text-sec__arrow-sticky')) {
              const titleStickyEl = section.querySelector(
                '.text-sec__title-sticky'
              );

              centerPosition = centerPosition - 50;

              if (titleStickyEl) {
                trackHeight =
                  wrap.clientHeight - distance - titleStickyEl.clientHeight;
              }
            }

            const arrowEl = document.querySelector('.text-sec__arrow-wr');
            if (arrowEl) {
              arrowEl.style.setProperty(
                '--center-position',
                `${centerPosition}px`
              );
            }

            start = `top top+=${
              window.innerHeight < 810 ? 120 : centerPosition
            }`;
          }

          ScrollTrigger.create({
            trigger: stickyEl,
            start: start,
            end: `+=${trackHeight}`,
            pin: true,
            pinSpacing: false,
            scrub: true,
            // markers: true,
          });

          const pinSpacer = stickyEl.closest('.pin-spacer');
          if (pinSpacer) {
            pinSpacer.classList.add('sticky-text-element');
          }
        });
      }, 1200);
    }
  }
};

if (!document.querySelector('.bold-loader-new')) {
  textStickyAnimation();
}

window.textStickyMobAnimation = function textStickyMobAnimation() {
  if (window.innerWidth <= 1024) {
    let tl = gsap.timeline();
    const stickyTextArr = document.querySelectorAll('[data-text-sticky-mob]');
    if (stickyTextArr.length >= 1) {
      setTimeout(function () {
        stickyTextArr.forEach((stickyEl) => {
          const section = stickyEl.closest('section');
          const wrap = section?.querySelector('.cont');

          if (!section || !wrap) {
            return;
          }

          const wrapRect = wrap.getBoundingClientRect();
          const stickyRect = stickyEl.getBoundingClientRect();

          const distance = stickyRect.top - wrapRect.top;

          let nextElHeight = stickyEl.nextElementSibling
            ? stickyEl.nextElementSibling.clientHeight
            : 0;

          if (window.innerWidth > 640) {
            nextElHeight = 0;
          }

          let trackHeight = wrap.clientHeight - distance;

          if (stickyEl.classList.contains('if-minus-height-el-mob')) {
            trackHeight =
              wrap.clientHeight -
              distance -
              stickyEl.clientHeight -
              nextElHeight;
          }

          let start = `top top+=${window.innerHeight < 810 ? 290 : 190}`;

          ScrollTrigger.create({
            trigger: stickyEl,
            start: start,
            end: `+=${trackHeight}`,
            pin: true,
            pinSpacing: false,
            scrub: 1,
            // markers: true,
          });

          const pinSpacer = stickyEl.closest('.pin-spacer');
          if (pinSpacer) {
            pinSpacer.classList.add('sticky-text-element');
          }
        });
      }, 1200);
    }
  }
};

if (!document.querySelector('.bold-loader-new')) {
  textStickyAnimation();
}
